module.exports = __webpack_public_path__ + "static/when-christmas-start-d215ab77fa7687571e0a0a87650ce04f.png";